import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from 'lucide-react';
interface MetricCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  icon?: React.ReactNode;
}
export function MetricCard({
  label,
  value,
  subtitle,
  trend,
  trendValue,
  icon
}: MetricCardProps) {
  const trendColor = trend === 'up' ? 'text-emerald-400' : trend === 'down' ? 'text-red-400' : 'text-white/30';
  const TrendIcon = trend === 'up' ? TrendingUpIcon : trend === 'down' ? TrendingDownIcon : MinusIcon;
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-4 flex flex-col justify-between gap-2 overflow-hidden min-h-[100px] sm:min-h-[110px]" style={{
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)'
  }} data-id="element-31">
      {/* Header */}
      <div className="flex items-start justify-between gap-2" data-id="element-32">
        <span className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-white/40 leading-tight" data-id="element-33">
          {label}
        </span>
        {icon && <span className="text-white/20 flex-shrink-0" data-id="element-34">{icon}</span>}
      </div>

      {/* Value & Trend */}
      <div className="flex flex-col gap-0.5" data-id="element-35">
        <span className="text-xl sm:text-2xl font-bold text-white tracking-tight truncate" data-id="element-36">
          {value}
        </span>

        {trend && trendValue && <div className={`flex items-center gap-1 text-[10px] sm:text-xs font-medium ${trendColor}`} data-id="element-37">
            <TrendIcon className="w-3 h-3 flex-shrink-0" data-id="element-38" />
            <span className="truncate" data-id="element-39">{trendValue}</span>
          </div>}

        {subtitle && <span className="text-[10px] sm:text-xs text-white/30 truncate" data-id="element-40">
            {subtitle}
          </span>}
      </div>
    </div>;
}